import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { REPORT_VIEWER_PAGE_METADATA } from './pageMetadata.js';
import { pageStyles } from './components/cssstyles.js';
import { ProjectContext } from './components/project-context.js';
import { resetcss } from './resetcss.js';
import { RouteConfig } from './router.js';
import { tasks } from './tasks.js';

@customElement('page-report-viewer-landing')
export class PageReportViewerLanding extends LitElement {
  static routes(): RouteConfig[] {
    return [{
      path: [
        '/',
      ],
      render: (groups) => ProjectContext.render({
      }, html`
        <page-report-viewer-landing .testId=${groups?.testId}></page-report-viewer-landing>
      `),
    }];
  }

  private _pageMetadataTask = tasks.pageMetadata(this, {
    args: () => [],
    metadata: () => REPORT_VIEWER_PAGE_METADATA,
  });

  override render() {
    return html`
      <report-viewer-header></report-viewer-header>
      <app-body-card style="background-color: var(--fk-color-canvas);">
        <h1>Flakiness Report Viewer</h1>
        <p>A local, offline-capable web app for viewing Flakiness reports.</p>
      </app-body-card>
      <app-footer style="background-color: var(--fk-color-canvas);"></app-footer>
    `
  }

  static styles = [resetcss, pageStyles, css`
  `];
}
